import { createContext, useContext } from 'react';

// What the marketplace header needs from the app (account, language, sign-out)
// without every market page passing it down. Provided once in App.js.
export const MarketChromeContext = createContext({});
export const useMarketChrome = () => useContext(MarketChromeContext);

/** Market pages carry MAABAR's ONE header (MarketBar); the site navbar is not shown there. */
export const isMarketPath = (pathname) => pathname === '/market' || pathname.startsWith('/market/');
